import { PaginationParams } from "@/types";

export const initPagination: PaginationParams = {
  pageIndex: 1,
  pageSize: 10,
};
